export default {
  title: 'Michelin HP',
  navColor: 'transparent',
  navTextColor: 'grey-9',
  showNav: false
};